class ComparePriceInfo {
  constructor() {
    this.modal = document.querySelector('#compare-price-modal');
    this.triggers = document.querySelectorAll('.compare-price-info-trigger');
    this.closeBtn = this.modal?.querySelector('.modal-close');
    this.overlay = this.modal?.querySelector('.modal-overlay');
    
    this.init();
  }

  init() {
    if (!this.modal) return;

    // Click handlers
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close handlers
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    
    // Keyboard handlers
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Focus trap
    const focusableElements = this.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length) {
      focusableElements[0].focus();
    }
  }

  close() {
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ComparePriceInfo());
} else {
  new ComparePriceInfo();
}